import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromQuotes from './+state/feature-config.reducers';
import { FeatureConfigEffects } from './+state/feature-config.effects';
import { FeatureConfigApiService } from './services/feature-config-api.service';
import { FeatureConfigFacade } from './+state/feature-config.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromQuotes.FEATURE_CONFIG_FEATURE_KEY,
      fromQuotes.reducer
    ),
    EffectsModule.forFeature([FeatureConfigEffects]),
  ],
  providers: [FeatureConfigApiService, FeatureConfigFacade],
})
export class CommonDataAccessFeatureConfigModule {}
